// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__11N4O","additionalInfo":"AgreementModal_additionalInfo__cS1LC"};